// Copyright (c) 2023 Deere & Company

import actions from '../../../sharedmodules/actions-list';
import { getDefaultState as getDuplicatePinPlateDefaultState } from '../state/duplicate-pin-plate-view';

export const resetDuplicatePinPlate = () => (dispatch) => dispatch({
    data: getDuplicatePinPlateDefaultState(),
    type: actions.RESET_DUPLICATE_PIN_PLATE,
});
